import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type ValidatePromoCodeQueryVariables = Types.Exact<{
  input: Types.ValidatePromoCodeInput;
}>;

export type ValidatePromoCodeQuery = {
  __typename?: 'Query';
  validatePromoCode: {
    __typename?: 'PromoCodeValidationResult';
    valid: boolean;
    applicableQuantity: number;
    discountType?: Types.PromoCodeDiscountType | null;
    discountValue?: number | null;
    currency?: string | null;
    code?: string | null;
  };
};

export const ValidatePromoCodeDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ValidatePromoCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ValidatePromoCodeInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'validatePromoCode' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'valid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicableQuantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountValue' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useValidatePromoCodeQuery__
 *
 * To run a query within a React component, call `useValidatePromoCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePromoCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePromoCodeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePromoCodeQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
  return ApolloReactHooks.useQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, baseOptions);
}
export function useValidatePromoCodeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>(ValidatePromoCodeDocument, baseOptions);
}
export type ValidatePromoCodeQueryHookResult = ReturnType<typeof useValidatePromoCodeQuery>;
export type ValidatePromoCodeLazyQueryHookResult = ReturnType<typeof useValidatePromoCodeLazyQuery>;
export type ValidatePromoCodeQueryResult = Apollo.QueryResult<ValidatePromoCodeQuery, ValidatePromoCodeQueryVariables>;
